// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3d809bac","703":"a7f924ca","737":"1fc653b6","787":"3ee01018"}[chunkId] + ".chunk.js";
};